
// eslint-disable-next-line no-unused-vars
const _financeVersion0Api = '/api/v0';
const apiEndpoints = {

  // Auth Module
  PUBLIC_BILL_API: "/api/public/bills",
  ADMIN_REGISTER_API: "/api/auth/register",
  ADMIN_LOGIN_API: "/api/auth/login",
  ADMIN_RELOGIN_API: "/api/auth/me",
  ADMIN_LOGOUT_API: "/api/auth/logout",

  // Society Controller

  //---------Auth Module---------
  REGISTER_API: "/api/auth/register",
  SOCIETY_CONTROLLER_LOGIN_API: "/api/auth/login",
  SOCIETY_CONTROLLER_RELOGIN_API: "/api/auth/me",
  SOCIETY_CONTROLLER_LOGOUT_API: "/api/auth/logout",

  // SOCIETY MANAGEMENT MODULE- communities
  CTRL_COMMUNITY_LIST_API: "/api/societies",
  CTRL_SOCIETY_DROPDOWN_API: "/api/societies/dropdown",
  CTRL_CREATE_COMMUNITY_API: "/api/societies",
  CTRL_GET_COMMUNITY_API: "/api/societies",
  CTRL_GET_COMMUNITY_DETAILS_API: "/api/societies",
  CTRL_EDIT_COMMUNITY_API: "/api/societies",
  CTRL_DELETE_COMMUNITY_API: "/api/societies",

  // SOCIETY MANAGEMENT MODULE- Brands
  CTRL_BRAND_LIST_API: "/api/brands",
  CTRL_CREATE_BRAND_API: "/api/brands",
  CTRL_GET_BRAND_API: "/api/brands",
  CTRL_EDIT_BRAND_API: "/api/brands",




  // Location Module - Countries
  CTRL_GET_COUNTRIES_API: "/api/countries",
  CTRL_GET_COUNTRY_DETAILS_API: "/api/countries/:id",
  CTRL_CREATE_COUNTRY_API: "/api/countries",
  CTRL_EDIT_COUNTRY_API: "/api/countries/:id",
  CTRL_DELETE_COUNTRY_API: "/api/countries/:id",

  // Location Module - States
  CTRL_GET_STATES_API: "/api/states",
  CTRL_GET_STATE_DETAILS_API: "/api/states/:id",
  CTRL_CREATE_STATE_API: "/api/states",
  CTRL_EDIT_STATE_API: "/api/states/:id",
  CTRL_DELETE_STATE_API: "/api/states/:id",

  //Cities
  CTRL_GET_CITIES_API: "/api/cities",
  CTRL_GET_CITY_DETAILS_API: "/api/cities/:id",
  CTRL_CREATE_CITY_API: "/api/cities",
  CTRL_EDIT_CITY_API: "/api/cities/:id",
  CTRL_DELETE_CITY_API: "/api/cities/:id",

  // Society Controller - Employees (cross-society directory)
  CTRL_EMPLOYEE_LIST_API: "/api/employees",
  CTRL_EMPLOYEE_DIRECTORY_API: "/api/employees/directory",
  CTRL_EMPLOYEE_STATS_API: "/api/employees/stats",
  CTRL_EMPLOYEE_BULK_STATUS_API: "/api/employees/bulk-status",
  CTRL_EMPLOYEE_BULK_REASSIGN_API: "/api/employees/bulk-reassign",
  CTRL_EMPLOYEE_BULK_UPLOAD_API: "/api/employees/bulk-upload",
  SOCIETY_EMPLOYEE_UPLOAD_TEMPLATE_API: "/api/employees/bulk-template",
  CTRL_EMPLOYEE_DETAILS_API: "/api/employees/:id",
  CTRL_EMPLOYEE_SOCIETIES_API: "/api/employees/:id/societies",
  CTRL_EMPLOYEE_SOCIETY_ROLE_API: "/api/employees/:id/societies/:societyId/role",
  CTRL_EMPLOYEE_CREATE_API: "/api/employees",
  CTRL_EMPLOYEE_UPDATE_API: "/api/employees/:id",
  CTRL_EMPLOYEE_DELETE_API: "/api/employees/:id",
  CTRL_EMPLOYEE_LINK_EXISTING_API: "/api/employees/link-existing",
  CTRL_EMPLOYEE_SEARCH_BY_EMAIL_API: "/api/employees/search-by-email",
  CTRL_EMPLOYEE_CHANGE_PASSWORD_API: "/api/employees/:id/password",
  CTRL_COMMUNICATION_SETTINGS_API: "/api/communication-settings",
  CTRL_SMTP_CONFIGS_API: "/api/society-smtp-configs",
  CTRL_SMTP_CONFIG_API: "/api/society-smtp-configs/:id",

  // Society Controller - Default (system) Roles & Permissions (super-admin)
  CTRL_SYS_ROLES_LIST_API: "/api/roles",
  CTRL_SYS_ROLE_DETAILS_API: "/api/roles/:id",
  CTRL_SYS_PERMISSION_CATALOG_API: "/api/roles/permissions",
  CTRL_SYS_PERMISSION_CATALOG_GROUPED_API: "/api/roles/permissions/grouped",
  CTRL_SYS_ROLE_CREATE_API: "/api/roles",
  CTRL_SYS_ROLE_UPDATE_API: "/api/roles/:id",
  CTRL_SYS_ROLE_SET_PERMISSIONS_API: "/api/roles/:id/permissions",
  CTRL_SYS_ROLE_DELETE_API: "/api/roles/:id",

  // Society Controller - Employee Types (roles catalog)
  CTRL_EMPLOYEE_ROLES_DROPDOWN_API: "/api/employee-roles/dropdown",
  CTRL_EMPLOYEE_ROLES_LIST_API: "/api/employee-roles",
  CTRL_EMPLOYEE_ROLE_DETAILS_API: "/api/employee-roles/:id",
  CTRL_EMPLOYEE_ROLE_CREATE_API: "/api/employee-roles",
  CTRL_EMPLOYEE_ROLE_UPDATE_API: "/api/employee-roles/:id",
  CTRL_EMPLOYEE_ROLE_DELETE_API: "/api/employee-roles/:id",


  // Society Portal - Society Profile
  GET_SOCIETY_PROFILE_API: "/api/societies/:id",
  UPDATE_SOCIETY_PROFILE_API: "/api/societies/:id",
  UPLOAD_SOCIETY_LOGO_API: "/api/societies/:id/logo",
  UPDATE_SOCIETY_GEOFENCE_API: "/api/societies/:id/geofence",
  // Society Portal - Invoice Settings
  GET_INVOICE_SETTINGS_API: "/api/invoice-settings",
  UPDATE_INVOICE_SETTINGS_API: "/api/invoice-settings",

  // Society Portal - Invoice Types
  GET_INVOICE_TYPES_API: "/api/invoice-types",
  GET_INVOICE_TYPE_DETAILS_API: "/api/invoice-types/:id",
  CREATE_INVOICE_TYPE_API: "/api/invoice-types",
  UPDATE_INVOICE_TYPE_API: "/api/invoice-types/:id",
  DELETE_INVOICE_TYPE_API: "/api/invoice-types/:id",

  // Society Portal - Document Series
  GET_DOCUMENT_SERIES_API: "/api/document-series",
  GET_DOCUMENT_SERIES_DETAILS_API: "/api/document-series/:id",
  CREATE_DOCUMENT_SERIES_API: "/api/document-series",
  UPDATE_DOCUMENT_SERIES_API: "/api/document-series/:id",
  DELETE_DOCUMENT_SERIES_API: "/api/document-series/:id",
  PREVIEW_DOCUMENT_SERIES_API: "/api/document-series/preview",

  CTRL_GET_PROFILE_API: "api/auth/profile",
  CTRL_UPDATE_PROFILE_API: "api/auth/profile",
  CTRL_CHANGE_PASSWORD: "api/auth/change-password",

  /* =========================
   SOCIETY – WINGS APIs
========================= */
  SOCIETY_GET_WINGS_API: "/api/wings",
  SOCIETY_GET_WING_DETAILS_API: "/api/wings/:id",
  SOCIETY_CREATE_WINGS_API: "/api/wings",
  SOCIETY_EDIT_WINGS_API: "/api/wings/:id",
  SOCIETY_DELETE_WINGS_API: "/api/wings/:id",
  SOCIETY_BULK_UPLOAD_WINGS_API: "/api/wings/bulk-upload",

  SOCIETY_GET_FLATS_API: "/api/flats",
  SOCIETY_GET_FLAT_DETAILS_API: "/api/flats/:id",
  SOCIETY_CREATE_FLAT_API: "/api/flats",
  SOCIETY_EDIT_FLAT_API: "/api/flats/:id",
  SOCIETY_DELETE_FLAT_API: "/api/flats/:id",
  SOCIETY_BULK_UPLOAD_FLATS_API: "/api/flats/bulk-upload",

  // Dropdown APIs
  SOCIETY_GET_WINGS_DROPDOWN_API: "/api/wings/dropdown",
  SOCIETY_GET_FLATS_DROPDOWN_API: "/api/flats/dropdown",
  SOCIETY_GET_FLATS_WITH_OWNERSHIP_API: "/api/flat-ownerships/flats-with-ownership",
  SOCIETY_GET_WING_OCCUPANCY_API: "/api/wings/occupancy-summary",

  /* =========================
   SOCIETY – TARIFF HEADS (Charge Heads) APIs
========================= */
  GET_TARIFF_HEADS_API: "/api/tariff-heads",
  GET_TARIFF_HEADS_WITH_DETAILS_API: "/api/tariff-heads/with-details",
  GET_TARIFF_HEAD_DETAILS_API: "/api/tariff-heads/:id",
  CREATE_TARIFF_HEAD_API: "/api/tariff-heads",
  UPDATE_TARIFF_HEAD_API: "/api/tariff-heads/:id",
  UPDATE_TARIFF_HEAD_STATUS_API: "/api/tariff-heads/:id/status",
  DELETE_TARIFF_HEAD_API: "/api/tariff-heads/:id",

  /* =========================
   SOCIETY – TAX RULES APIs
========================= */
  GET_TAX_RULES_API: "/api/tax-rules",
  CREATE_TAX_RULE_API: "/api/tax-rules",
  UPDATE_TAX_RULE_API: "/api/tax-rules/:id",
  DELETE_TAX_RULE_API: "/api/tax-rules/:id",

  /* =========================
   SOCIETY – TARIFF RATES APIs
========================= */
  GET_TARIFF_RATES_API: "/api/tariff-rates",
  GET_TARIFF_RATES_BY_HEAD_API: "/api/tariff-rates/by-head/:head_id",
  GET_TARIFF_RATE_DETAILS_API: "/api/tariff-rates/:id",
  CREATE_TARIFF_RATE_API: "/api/tariff-rates",
  UPDATE_TARIFF_RATE_API: "/api/tariff-rates/:id",
  UPDATE_TARIFF_RATE_STATUS_API: "/api/tariff-rates/:id/status",
  DELETE_TARIFF_RATE_API: "/api/tariff-rates/:id",

  /* =========================
   SOCIETY – INVOICES APIs
========================= */
  GET_INVOICES_API: "/api/invoices",
  GET_INVOICE_DETAILS_API: "/api/invoices/:id",
  GET_INVOICE_STATISTICS_API: "/api/invoices/statistics",
  GET_INVOICES_BY_FLAT_API: "/api/invoices/flat/:flat_id",
  GET_UNPAID_INVOICES_BY_FLAT_API: "/api/invoices/flat/:flat_id/unpaid",
  CREATE_INVOICE_API: "/api/invoices",
  UPDATE_INVOICE_API: "/api/invoices/:id",
  UPDATE_DRAFT_INVOICE_API: "/api/invoices/:id/draft",
  DELETE_INVOICE_API: "/api/invoices/:id",
  VOID_INVOICE_API: "/api/invoices/:id/void",
  POST_INVOICE_API: "/api/invoices/:id/post",
  BULK_INVOICE_DETAILS_API: "/api/invoices/bulk/details",
  BULK_POST_INVOICES_API: "/api/invoices/bulk/post",
  BULK_DELETE_INVOICES_API: "/api/invoices/bulk/delete",
  BULK_PREVIEW_INVOICES_API: "/api/invoices/bulk/preview",
  BULK_CREATE_INVOICES_API: "/api/invoices/bulk/create",
  GET_ARREARS_BY_FLAT_API: "/api/arrears/flat/:flat_id",

  /* =========================
   SOCIETY – CREDIT/DEBIT NOTES APIs
========================= */
  GET_CREDIT_DEBIT_NOTES_API: "/api/credit-debit-notes",
  GET_CREDIT_DEBIT_NOTE_DETAILS_API: "/api/credit-debit-notes/:id",
  GET_CREDIT_DEBIT_NOTES_BY_INVOICE_API: "/api/credit-debit-notes/invoice/:invoice_id",
  CREATE_CREDIT_DEBIT_NOTE_API: "/api/credit-debit-notes",
  UPDATE_CREDIT_DEBIT_NOTE_API: "/api/credit-debit-notes/:id",
  POST_CREDIT_DEBIT_NOTE_API: "/api/credit-debit-notes/:id/post",
  VOID_CREDIT_DEBIT_NOTE_API: "/api/credit-debit-notes/:id/void",
  DELETE_CREDIT_DEBIT_NOTE_API: "/api/credit-debit-notes/:id",
  DOWNLOAD_CREDIT_DEBIT_NOTE_TEMPLATE_API: "/api/credit-debit-notes/template/download",
  BULK_UPLOAD_CREDIT_DEBIT_NOTES_API: "/api/credit-debit-notes/bulk/upload",
  BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_API: "/api/credit-debit-notes/bulk/details",
  BULK_POST_CREDIT_DEBIT_NOTES_API: "/api/credit-debit-notes/bulk/post",
  BULK_DELETE_CREDIT_DEBIT_NOTES_API: "/api/credit-debit-notes/bulk/delete",

  /* =========================
   SOCIETY – RECEIPTS APIs
========================= */
  GET_RECEIPTS_API: "/api/receipts",
  GET_RECEIPT_DETAILS_API: "/api/receipts/:id",
  GET_RECEIPTS_BY_FLAT_API: "/api/receipts/flat/:flat_id",
  CREATE_RECEIPT_API: "/api/receipts",
  UPDATE_RECEIPT_API: "/api/receipts/:id",
  DELETE_RECEIPT_API: "/api/receipts/:id",
  CLEAR_RECEIPT_API: "/api/receipts/:id/clear",
  BOUNCE_RECEIPT_API: "/api/receipts/:id/bounce",
  GET_OUTSTANDING_DOCUMENTS_API: "/api/receipts/flat/:flat_id/outstanding",
  CALCULATE_ALLOCATION_COMPONENTS_API: "/api/receipts/allocations/calculate-components",
  UPDATE_RECEIPT_ALLOCATIONS_API: "/api/receipts/:id/allocations",
  BULK_UPLOAD_RECEIPTS_API: "/api/receipts/bulk-upload",
  BULK_GET_RECEIPT_DETAILS_API: "/api/receipts/bulk/details",
  BULK_CANCEL_RECEIPTS_API: "/api/receipts/bulk/cancel",
  BULK_BOUNCE_RECEIPTS_API: "/api/receipts/bulk/bounce",
  BULK_CLEAR_RECEIPTS_API: "/api/receipts/bulk/clear",

  /* =========================
   SOCIETY – OCCUPANTS APIs
========================= */
  GET_OCCUPANTS_API: "/api/occupants",
  DOWNLOAD_OCCUPANTS_EXCEL_API: "/api/occupants/download",
  DOWNLOAD_OCCUPANT_TEMPLATE_API: "/api/occupants/template",
  BULK_UPLOAD_OCCUPANTS_API: "/api/occupants/bulk-upload",
  GET_ASSIGNABLE_MEMBER_ROLES_API: "/api/occupants/assignable-roles",
  GET_OCCUPANT_DETAILS_API: "/api/occupants/:id",
  CREATE_OCCUPANT_API: "/api/occupants",
  UPDATE_OCCUPANT_API: "/api/occupants/:id",
  DELETE_OCCUPANT_API: "/api/occupants/:id",
  UPLOAD_OCCUPANT_DOCUMENT_API: "/api/occupants/:id/documents",
  LIST_OCCUPANT_DOCUMENTS_API: "/api/occupants/:id/documents",
  DELETE_OCCUPANT_DOCUMENT_API: "/api/occupants/documents/:documentId",
  SET_TENANT_STATUS_API: "/api/occupants/:id/status",
  GET_TENANT_HISTORY_API: "/api/occupants/tenant-history",

  /* =========================
   SOCIETY – METER READINGS APIs
========================= */
  GET_METER_READINGS_API: "/api/meter-readings",
  GET_METER_READING_DETAILS_API: "/api/meter-readings/:id",
  GET_LAST_METER_READING_API: "/api/meter-readings/last-reading",
  CREATE_METER_READING_API: "/api/meter-readings",
  CREATE_BULK_METER_READINGS_API: "/api/meter-readings/bulk",
  UPLOAD_METER_READINGS_API: "/api/meter-readings/upload",
  DOWNLOAD_METER_READING_TEMPLATE_API: "/api/meter-readings/template",
  UPDATE_METER_READING_API: "/api/meter-readings/:id",
  DELETE_METER_READING_API: "/api/meter-readings/:id",

  /* =========================
   SOCIETY – METER SLABS APIs
========================= */
  GET_METER_SLABS_API: "/api/tariff-meter-slabs",
  GET_METER_SLABS_BY_HEAD_API: "/api/tariff-meter-slabs/by-head",
  GET_METER_SLAB_DETAILS_API: "/api/tariff-meter-slabs/:id",
  CREATE_METER_SLAB_API: "/api/tariff-meter-slabs",
  CREATE_BULK_METER_SLABS_API: "/api/tariff-meter-slabs/bulk",
  UPDATE_METER_SLAB_API: "/api/tariff-meter-slabs/:id",
  UPDATE_METER_SLAB_STATUS_API: "/api/tariff-meter-slabs/:id/status",
  DELETE_METER_SLAB_API: "/api/tariff-meter-slabs/:id",

  /* =========================
   SOCIETY – JOURNALS APIs
========================= */
  GET_JOURNALS_API: "/api/accounts/journals/:societyId",
  GET_JOURNAL_DETAILS_API: "/api/accounts/journals/:societyId/:journalId",
  CREATE_JOURNAL_API: "/api/accounts/journals/",
  UPDATE_JOURNAL_API: "/api/accounts/journals/:societyId/:journalId",
  DELETE_JOURNAL_API: "/api/accounts/journals/:societyId/:journalId",
  GET_ACCOUNT_HEADS_API: "/api/accounts/heads/:societyId",
  GET_JOURNAL_AUDIT_LOGS_API: "/api/accounts/journals/auditLog/:societyId/:journalId",
  BULK_VALIDATE_JOURNALS_API: "/api/accounts/journals/:societyId/bulk-validate",
  BULK_UPLOAD_JOURNALS_API: "/api/accounts/journals/:societyId/bulk-upload",

  // Chart of Accounts
  GET_CHART_OF_ACCOUNTS_API: "/api/accounts/chartOfAccounts/:societyId",
  CREATE_CHART_OF_ACCOUNT_API: "/api/accounts/chartOfAccounts/:societyId",
  GET_CHART_OF_ACCOUNTS_DROPDOWN_API: "/api/accounts/chartOfAccounts/:societyId/dropdown",

  // GL Accounts (Non-Group, Excluding Expenses)
  GET_GL_ACCOUNTS_API: "/api/accounts/gl/:societyId",

  /* =========================
    SOCIETY –  APIs
 ========================= */
  SOCIETY_GET_COUNTRIES_API: "/api/countries",
  SOCIETY_GET_STATE_API: "/api/states",
  SOCIETY_GET_CITY_API: "/api/cities",


  // Society Portal - Employees
  SOCIETY_GET_EMPLOYEES_LIST_API: "/api/employees",
  SOCIETY_GET_EMPLOYEE_DETAILS_API: "/api/employees/:id",
  SOCIETY_CREATE_EMPLOYEE_API: "/api/employees/add",
  SOCIETY_UPDATE_EMPLOYEE_API: "/api/employees/:id",
  SOCIETY_DELETE_EMPLOYEE_API: "/api/employees/:id",
  SOCIETY_GET_EMPLOYEE_TYPES_API: "/api/employee-roles/dropdown",
  SOCIETY_GET_EMPLOYEES_DROPDOWN_API: "/api/employees/dropdown",
  SOCIETY_GET_COUNTRIES_DROPDOWN_API: "/api/countries",
  SOCIETY_GET_EMPLOYEE_AUDIT_LOG_API: "/api/audit-logs/employees",
  SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_API: "/api/employees/search-by-email",
  SOCIETY_LINK_EXISTING_EMPLOYEE_API: "/api/employees/link-existing",
  SOCIETY_GET_USERNAMES_DROPDOWN_API: "/api/users/dropdown",
  SOCIETY_GET_EMPLOYEE_LOGIN_REPORT_USERS_API: "/api/employees/login-report/users",
  SOCIETY_GET_EMPLOYEE_WORK_LOG_API: "/api/employees/work-log",
  COMMITTEE_MANAGERS_API: "/api/committee-oversight/managers",
  COMMITTEE_COMPLAINTS_API: "/api/committee-oversight/complaints",
  COMMITTEE_COMPLAINT_DETAIL_API: "/api/committee-oversight/complaints/:id",
  COMMITTEE_MANAGER_TASKS_API: "/api/committee-oversight/tasks",
  COMMITTEE_MANAGER_TASK_DETAIL_API: "/api/committee-oversight/tasks/:id",
  COMMITTEE_ROLES_API: "/api/committee-oversight/committee-roles",
  COMMITTEE_MEMBERS_API: "/api/committee-oversight/members",
  COMMITTEE_MEMBER_DELETE_API: "/api/committee-oversight/members/:id",
  COMMITTEE_ELIGIBLE_USERS_API: "/api/committee-oversight/eligible-users",

  // Society Portal - Attendance (geofenced login/logout history)
  SOCIETY_GET_ATTENDANCE_REPORT_API: "/api/login-history/attendance",
  SOCIETY_EXPORT_ATTENDANCE_REPORT_API: "/api/login-history/attendance/export",

  // Society Portal - Employee Attendance (shift punch in/out) — self-service.
  // These are scoped to the token's employee record; no permission needed.
  SOCIETY_ATTENDANCE_ENUMS_API: "/api/attendance/enums",
  SOCIETY_ATTENDANCE_MY_STATUS_API: "/api/attendance/me/status",
  SOCIETY_ATTENDANCE_MY_PUNCHES_API: "/api/attendance/me",
  SOCIETY_ATTENDANCE_MY_SUMMARY_API: "/api/attendance/me/summary",
  SOCIETY_ATTENDANCE_PUNCH_API: "/api/attendance/punch",
  // Admin attendance management
  SOCIETY_ATTENDANCE_DAILY_API: "/api/attendance/daily",
  SOCIETY_ATTENDANCE_ADMIN_SUMMARY_API: "/api/attendance/summary",
  SOCIETY_ATTENDANCE_EXPORT_API: "/api/attendance/export",
  SOCIETY_ATTENDANCE_ADMIN_PUNCHES_API: "/api/attendance",
  SOCIETY_ATTENDANCE_MANUAL_PUNCH_API: "/api/attendance/manual",
  SOCIETY_ATTENDANCE_APPROVE_PUNCH_API: "/api/attendance/:id/approve",
  SOCIETY_ATTENDANCE_REJECT_PUNCH_API: "/api/attendance/:id/reject",
  SOCIETY_UPDATE_ATTENDANCE_PUNCH_API: "/api/attendance/:id",

  // Society Portal - Employee Shifts. A shift definition is the template; an
  // assignment says who works one, from when. There is no roster: an assignment
  // is the whole schedule, not a day-by-day calendar.
  SOCIETY_SHIFT_ENUMS_API: "/api/shifts/enums",
  SOCIETY_SHIFTS_API: "/api/shifts",
  SOCIETY_SHIFT_BY_ID_API: "/api/shifts/:id",

  SOCIETY_SHIFT_ASSIGNMENTS_API: "/api/shift-assignments",
  SOCIETY_SHIFT_ASSIGNMENT_BY_ID_API: "/api/shift-assignments/:id",
  SOCIETY_END_SHIFT_ASSIGNMENT_API: "/api/shift-assignments/:id/end",

  // Society Portal - Complaints
  SOCIETY_GET_COMPLAINTS_LIST_API: "/api/complaints",
  SOCIETY_GET_COMPLAINT_DETAILS_API: "/api/complaints/:id",
  SOCIETY_CREATE_COMPLAINT_API: "/api/complaints",
  SOCIETY_UPDATE_COMPLAINT_API: "/api/complaints/:id",
  SOCIETY_DELETE_COMPLAINT_API: "/api/complaints/:id",
  SOCIETY_CHANGE_COMPLAINT_STATUS_API: "/api/complaints/:id/status",
  SOCIETY_ASSIGN_COMPLAINT_API: "/api/complaints/:id/assign",
  SOCIETY_COMPLAINT_COMMENTS_API: "/api/complaints/:id/comments",
  SOCIETY_COMPLAINT_ATTACHMENTS_API: "/api/complaints/:id/attachments",
  SOCIETY_DELETE_COMPLAINT_ATTACHMENT_API: "/api/complaints/:id/attachments/:attachmentId",
  SOCIETY_RATE_COMPLAINT_API: "/api/complaints/:id/rate",
  SOCIETY_GET_COMPLAINT_AUDIT_LOG_API: "/api/audit-logs/complaints",
  SOCIETY_GET_COMPLAINT_ENUMS_API: "/api/complaints/enums",
  SOCIETY_GET_COMPLAINT_STATS_API: "/api/complaints/stats",
  SOCIETY_GET_EMPLOYEE_COMPLAINTS_API: "/api/complaints/by-employee",

  // Complaint Categories
  SOCIETY_GET_COMPLAINT_CATEGORIES_API: "/api/complaint-categories",
  SOCIETY_GET_COMPLAINT_CATEGORY_API: "/api/complaint-categories/:id",
  SOCIETY_CREATE_COMPLAINT_CATEGORY_API: "/api/complaint-categories",
  SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_API: "/api/complaint-categories/bulk",
  SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_API: "/api/complaint-categories/multi",
  SOCIETY_UPDATE_COMPLAINT_CATEGORY_API: "/api/complaint-categories/:id",
  SOCIETY_DELETE_COMPLAINT_CATEGORY_API: "/api/complaint-categories/:id",

  // Society Portal - Vendor
  SOCIETY_GET_VENDOR_CATEGORIES_API: "/api/vendors/categories",
  SOCIETY_CREATE_VENDOR_CATEGORY_API: "/api/vendors/categories",
  SOCIETY_UPDATE_VENDOR_CATEGORY_API: "/api/vendors/categories/:id",
  SOCIETY_DELETE_VENDOR_CATEGORY_API: "/api/vendors/categories/:id",
  SOCIETY_CREATE_VENDOR_API: "/api/vendors/create",
  SOCIETY_GET_VENDOR_DETAILS_API: "/api/vendors/details/:id",
  SOCIETY_GET_VENDORS_LIST_API: "/api/vendors/details",
  SOCIETY_UPDATE_VENDOR_API: "/api/vendors/update/:id",
  SOCIETY_DELETE_VENDOR_API: "/api/vendors/delete/:id",
  SOCIETY_GET_ALL_VENDORS_API: "/api/vendors/all",

  /* =========================
   SOCIETY – OPENING BALANCES APIs
========================= */
  // Opening-balance routes are mounted at /api/accounts/opening-balances
  // (see app.js). The flat-based manual create uses /manual to avoid
  // colliding with the double-entry POST / handler on the same router.
  GET_OPENING_BALANCES_API: "/api/accounts/opening-balances",
  GET_OPENING_BALANCE_DETAILS_API: "/api/accounts/opening-balances/:id",
  CREATE_OPENING_BALANCE_API: "/api/accounts/opening-balances/manual",
  UPDATE_OPENING_BALANCE_API: "/api/accounts/opening-balances/:id",
  DELETE_OPENING_BALANCE_API: "/api/accounts/opening-balances/:id",
  BULK_UPLOAD_OPENING_BALANCES_API: "/api/accounts/opening-balances/bulk-upload",
  DOWNLOAD_OPENING_BALANCE_TEMPLATE_API: "/api/accounts/opening-balances/template",

  // Society Portal - Vendor Tariffs
  SOCIETY_GET_VENDOR_TARIFFS_API: "/api/vendors/:vendorId/tariffs",
  SOCIETY_CREATE_VENDOR_TARIFF_API: "/api/vendors/:vendorId/tariffs",
  SOCIETY_DELETE_VENDOR_TARIFF_API: "/api/vendors/:vendorId/tariffs/:id",
  SOCIETY_GET_ALL_VENDOR_TARIFFS_API: "/api/vendors/:vendorId/tariffs/all",

  // Society Portal - Vendor Setting
  SOCIETY_GET_VENDOR_SETTING_API: "/api/vendors/:vendorId/setting",

  // Society Portal - Vendor Bills
  SOCIETY_GET_VENDOR_BILLS_LIST_API: "/api/vendors/bills/list",
  SOCIETY_GET_VENDOR_BILL_DETAILS_API: "/api/vendors/bills/:id",
  SOCIETY_CREATE_VENDOR_BILL_API: "/api/vendors/bills",
  SOCIETY_UPDATE_VENDOR_BILL_API: "/api/vendors/bills/:id",
  SOCIETY_DELETE_VENDOR_BILL_API: "/api/vendors/bills/:id",
  SOCIETY_APPROVE_VENDOR_BILL_API: "/api/vendors/bills/:id/approve",
  SOCIETY_PAY_VENDOR_BILL_API: "/api/vendors/bills/:id/pay",

  // Society Portal - Vendor Bank Accounts
  SOCIETY_GET_VENDOR_BANK_ACCOUNTS_API: "/api/vendors/:vendorId/bank-accounts",
  SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_API: "/api/vendors/:vendorId/bank-accounts",
  SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_API: "/api/vendors/:vendorId/bank-accounts/:id",
  SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_API: "/api/vendors/:vendorId/bank-accounts/:id",

  // Society Portal - Vendor AMC Tracker
  SOCIETY_GET_VENDOR_AMC_LIST_API: "/api/vendors/:vendorId/amc",
  SOCIETY_GET_VENDOR_AMC_DETAILS_API: "/api/vendors/:vendorId/amc/:id",
  SOCIETY_CREATE_VENDOR_AMC_API: "/api/vendors/:vendorId/amc",
  SOCIETY_UPDATE_VENDOR_AMC_API: "/api/vendors/:vendorId/amc/:id",
  SOCIETY_DELETE_VENDOR_AMC_API: "/api/vendors/:vendorId/amc/:id",

  // Society Portal - Vendor GL Codes
  SOCIETY_GET_VENDOR_GL_CODES_API: "/api/vendors/glCodes",
  SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_API: "/api/vendors/getGlCode",
  // Excel bulk upload for vendors
  SOCIETY_VENDOR_UPLOAD_TEMPLATE_API: "/api/vendors/upload/template",
  SOCIETY_BULK_UPLOAD_VENDORS_API: "/api/vendors/upload",
  // Excel bulk upload for vendor bills
  SOCIETY_VENDOR_BILL_UPLOAD_TEMPLATE_API: "/api/vendors/bills/upload/template",
  SOCIETY_BULK_UPLOAD_VENDOR_BILLS_API: "/api/vendors/bills/upload",
  // Excel bulk upload for vendor payments
  SOCIETY_VENDOR_PAYMENT_UPLOAD_TEMPLATE_API: "/api/vendors/payments/upload/template",
  SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_API: "/api/vendors/payments/upload",

  // Society Portal - Vendor Round Off GL Code
  SOCIETY_GET_VENDOR_ROUND_OFF_GL_API: "/api/vendors/round-off-gl-code",

  // Society Portal - Vendor Payments
  SOCIETY_GET_VENDOR_PAYMENTS_LIST_API: "/api/vendors/payments/list",
  SOCIETY_GET_VENDOR_PAYMENT_DETAILS_API: "/api/vendors/payments/:id",
  SOCIETY_CREATE_VENDOR_PAYMENT_API: "/api/vendors/payments",
  SOCIETY_UPDATE_VENDOR_PAYMENT_API: "/api/vendors/payments/:id",
  SOCIETY_BULK_POST_VENDOR_PAYMENTS_API: "/api/vendors/payments/bulk-post",
  SOCIETY_BULK_POST_VENDOR_BILLS_API: "/api/vendors/bills/bulk-post",
  SOCIETY_DELETE_VENDOR_PAYMENT_API: "/api/vendors/payments/:id",
  SOCIETY_GET_VENDOR_UNPAID_BILLS_API: "/api/vendors/payments/unpaid-bills",

  // Society Portal - Vendor Billing Settings
  SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_API: "/api/vendors/billing-settings",
  SOCIETY_GET_VENDOR_BILLING_SETTINGS_API: "/api/vendors/billing-settings",
  SOCIETY_GET_VENDORS_DROPDOWN_API: "/api/vendors/dropdown",
  VENDOR_VISITS_API: "/api/vendor-visits",
  VENDOR_VISIT_DETAIL_API: "/api/vendor-visits/:id",
  VENDOR_VISITS_MONTHLY_API: "/api/vendor-visits/monthly",
  VENDOR_VISIT_VENDORS_API: "/api/vendor-visits/vendors",
  VENDOR_REMINDER_SETTINGS_API: "/api/vendor-reminders/settings",
  VENDOR_REMINDER_UPCOMING_API: "/api/vendor-reminders/upcoming",
  VENDOR_REMINDER_LOGS_API: "/api/vendor-reminders/logs",
  VENDOR_REMINDER_RUN_API: "/api/vendor-reminders/run-now",
  SOCIETY_DOCUMENTS_API: "/api/society-documents",
  SOCIETY_DOCUMENT_DETAIL_API: "/api/society-documents/:id",
  SOCIETY_DOCUMENT_VERSIONS_API: "/api/society-documents/:id/versions",
  SOCIETY_DOCUMENT_HISTORY_API: "/api/society-documents/:id/history",
  SOCIETY_DOCUMENT_ACCESS_API: "/api/society-documents/:id/access",
  SOCIETY_DOCUMENT_FILE_API: "/api/society-documents/:id/file",

  /* =========================
   SOCIETY – ACCOUNTS OPENING (Flat-level) APIs
========================= */
  GET_ACCOUNTS_OPENING_LIST_API: "/api/accounts/opening-balances",
  CREATE_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances",
  GET_ACCOUNTS_OPENING_BY_ID_API: "/api/accounts/opening-balances/:id",
  UPDATE_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances/:id",
  DELETE_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances/:id",
  DOWNLOAD_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances/download",
  BULK_UPLOAD_ACCOUNTS_OPENING_API: "/apiaccounts/opening-balances/bulk-upload",
  GET_GL_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances/:societyId/accounts",
  SAVE_GL_ACCOUNTS_OPENING_API: "/api/accounts/opening-balances",

  /* =========================
   SOCIETY – ACCOUNTS CLOSING APIs
========================= */
  GET_GL_ACCOUNTS_CLOSING_API: "/api/accounts/closing-balances/:societyId/accounts",
  CREATE_ACCOUNTS_CLOSING_API: "/api/accounts/closing-balances",

  /* =========================
   SOCIETY – MEMBER DAYBOOK APIs
========================= */
  GET_MEMBER_DAYBOOK_API: "/api/accounts/opening-balances/:societyId/member-daybook",

/* =========================
   SOCIETY – BANK ACCOUNTS APIs
========================= */
  GET_SOCIETY_BANKS_API: "/api/society-banks",
  GET_SOCIETY_BANK_DETAILS_API: "/api/society-banks/:id",
  CREATE_SOCIETY_BANK_API: "/api/society-banks",
  UPDATE_SOCIETY_BANK_API: "/api/society-banks/:id",
  DELETE_SOCIETY_BANK_API: "/api/society-banks/:id",
  GET_BANK_JOURNAL_ENTRIES_API: "/api/society-banks/:id/journal-entries",
  GET_SOCIETY_BANKS_DROPDOWN_API: "/api/society-banks/dropdown",

  /* =========================
   SOCIETY – FIXED ASSETS APIs
========================= */
  CREATE_FIXED_ASSET_API: "/api/fixed-assets/:societyId/assets",
  GET_FIXED_ASSETS_API: "/api/fixed-assets/:societyId/assets",
  GET_DEPRECIATION_METHODS_API: "/api/fixed-assets/depreciation-methods",
  GET_FIXED_ASSET_CATEGORIES_API: "/api/fixed-assets/:societyId/categories/tree",
  GET_FIXED_ASSET_DETAILS_API: "/api/fixed-assets/:societyId/assets/:id",
  UPDATE_FIXED_ASSET_API: "/api/fixed-assets/:societyId/assets/:id",
  DELETE_FIXED_ASSET_API: "/api/fixed-assets/:societyId/assets/:id",

/* =========================
   SOCIETY – CASH & BANK APIs
========================= */
  GET_CASH_BANK_LIST_API: "/api/v0/cash-bank/:societyId",
  GET_CASH_BANK_ENTRIES_API: "/api/v0/cash-bank/:societyId/entries/:glCode",
  GET_CASH_BANK_SUMMARY_API: "/api/v0/cash-bank/:societyId/summary/:glCode",

/* =========================
   SOCIETY – INVESTMENTS APIs
========================= */
  GET_INVESTMENTS_API: "/api/v0/investments/:societyId",
  GET_INVESTMENT_DETAILS_API: "/api/v0/investments/:societyId/:id",
  CREATE_INVESTMENT_API: "/api/v0/investments/:societyId",
  UPDATE_INVESTMENT_API: "/api/v0/investments/:societyId/:id",
  DELETE_INVESTMENT_API: "/api/v0/investments/:societyId/:id",
  CALCULATE_INVESTMENT_PREVIEW_API: "/api/v0/investments/calculate-preview",
  COLLECT_INVESTMENT_INTEREST_API: "/api/v0/investments/:societyId/:id/interests/:interestId/collect",
  DELETE_INVESTMENT_INTEREST_API: "/api/v0/investments/:societyId/:id/interests/:interestId",
  MATURE_INVESTMENT_API: "/api/v0/investments/:societyId/:id/mature",
  PRE_MATURE_INVESTMENT_API: "/api/v0/investments/:societyId/:id/pre-mature",
  RENEW_INVESTMENT_API: "/api/v0/investments/:societyId/:id/renew",
  GET_INVESTMENT_SUMMARY_API: "/api/v0/investments/:societyId/summary",
  UPDATE_INVESTMENT_VALUATION_API: "/api/v0/investments/:societyId/:id/valuation",
  INVESTMENT_REMINDER_SETTINGS_API: "/api/investment-reminders/settings",
  INVESTMENT_REMINDER_LOGS_API: "/api/investment-reminders/logs",
  INVESTMENT_REMINDER_RUN_API: "/api/investment-reminders/run-now",
  DAILY_TODOS_API: "/api/daily-todos",
  DAILY_TODO_DETAIL_API: "/api/daily-todos/:id",
  DAILY_TODO_STATUS_API: "/api/daily-todos/status",

/* =========================
   SOCIETY – BRS APIs
========================= */
  GET_BRS_LIST_API: "/api/v0/brs/:societyId",
  GET_BRS_DETAILS_API: "/api/v0/brs/:societyId/:brsId",
  CREATE_BRS_API: "/api/v0/brs/:societyId",
  UPDATE_BRS_API: "/api/v0/brs/:societyId/:brsId",
  FINALIZE_BRS_API: "/api/v0/brs/:societyId/:brsId/finalize",
  DELETE_BRS_API: "/api/v0/brs/:societyId/:brsId",
  CLEAR_BRS_ENTRIES_API: "/api/v0/brs/:societyId/:brsId/clear",
  IMPORT_BRS_STATEMENT_API: "/api/v0/brs/:societyId/:brsId/import-statement",
  AUTO_MATCH_BRS_API: "/api/v0/brs/:societyId/:brsId/auto-match",
  MANUAL_MATCH_BRS_API: "/api/v0/brs/:societyId/:brsId/manual-match",
  UNMATCH_BRS_API: "/api/v0/brs/:societyId/:brsId/unmatch",

/* =========================
   SOCIETY – ACCOUNT REPORTS APIs
========================= */
  GET_INCOME_EXPENDITURE_REPORT_API: "/api/v0/account-reports/income-expenditure/:societyId",
  GET_BALANCE_SHEET_REPORT_API: "/api/v0/account-reports/balance-sheet/:societyId",
  GET_TRIAL_BALANCE_REPORT_API: "/api/v0/account-reports/trial-balance/:societyId",
  GET_GROUP_LEDGER_REPORT_API: "/api/v0/account-reports/group-ledger/:societyId",
  GET_ACCOUNT_LEDGER_REPORT_API: "/api/v0/account-reports/account-ledger/:societyId",
  GET_MONTHLY_INCOME_REPORT_API: "/api/v0/account-reports/monthly-income/:societyId",
  GET_MONTHLY_EXPENDITURE_REPORT_API: "/api/v0/account-reports/monthly-expenditure/:societyId",
  GET_MONTHLY_INCOME_EXPENDITURE_REPORT_API: "/api/v0/account-reports/income-expenditure-monthly/:societyId",

/* =========================
   SOCIETY – INVOICE REPORT APIs
========================= */
  GET_INVOICE_REPORT_API: "/api/invoice-reports",
  GET_INVOICE_AGING_REPORT_API: "/api/invoice-reports/aging",
  GET_INTEREST_REPORT_API: "/api/invoice-reports/interest",
  GET_RECEIPT_REPORT_API: "/api/receipt-reports",
  GET_CD_NOTE_REPORT_API: "/api/credit-debit-note-reports",
  GET_GST_REPORT_API: "/api/gst-reports",
  GET_RECONCILIATION_REPORT_API: "/api/reconciliation-reports",

  /* =========================
   SOCIETY – ROLES APIs
========================= */
  GET_SOCIETY_ROLES_API: "/api/societies/:societyId/roles",
  GET_SOCIETY_ROLE_DETAILS_API: "/api/societies/:societyId/roles/:roleId",
  CREATE_SOCIETY_ROLE_API: "/api/societies/:societyId/roles",
  UPDATE_SOCIETY_ROLE_API: "/api/societies/:societyId/roles/:roleId",
  DELETE_SOCIETY_ROLE_API: "/api/societies/:societyId/roles/:roleId",
  ASSIGN_ROLE_PERMISSIONS_API: "/api/societies/:societyId/roles/:roleId/permissions",
  GET_PERMISSION_CATALOG_API: "/api/societies/:societyId/roles/permissions",
  GET_PERMISSION_CATALOG_GROUPED_API: "/api/societies/:societyId/roles/permissions/grouped",

  /* =========================
   USER ↔ SOCIETY ASSIGNMENT APIs
========================= */
  GET_MY_SOCIETIES_API: "/api/user-societies/my-societies",
  GET_MY_PERMISSIONS_API: "/api/user-societies/my-permissions",
  GET_SOCIETY_USERS_API: "/api/user-societies/society/:societyId/users",
  CREATE_USER_SOCIETY_API: "/api/user-societies",
  UPDATE_USER_SOCIETY_API: "/api/user-societies/:id",
  DELETE_USER_SOCIETY_API: "/api/user-societies/:id",

  /* =========================
   COMPLIANCE – FLAT TRANSFER APIs
========================= */
  GET_FLAT_TRANSFER_PREVIEW_API:  "/api/flats/:flatId/transfer/preview",
  EXECUTE_FLAT_TRANSFER_API:      "/api/flats/:flatId/transfer",
  GET_FLAT_TRANSFER_HISTORY_API:  "/api/flats/:flatId/transfer-history",
  GET_FLAT_TRANSFER_DETAIL_API:   "/api/compliance/flat-transfers/:id",
  REVERSE_FLAT_TRANSFER_API:      "/api/compliance/flat-transfers/:id/reverse",
  ADD_FLAT_TRANSFER_DOCUMENT_API: "/api/compliance/flat-transfers/:id/documents",

  /* =========================
   COMPLIANCE – SHARE CERTIFICATE APIs
========================= */
  LIST_SHARE_CERTIFICATES_API:    "/api/compliance/share-certificates/society/:societyId",
  GET_SHARE_CERTIFICATE_API:      "/api/compliance/share-certificates/:id",
  SET_SHARE_CERTIFICATE_LIEN_API: "/api/compliance/share-certificates/:id/lien",

  /* =========================
   DASHBOARD APIs
========================= */
  GET_SOCIETY_DASHBOARD_API: "/api/dashboard/society/:societyId",
  GET_WEBMASTER_DASHBOARD_API: "/api/dashboard/webmaster",
  GET_OPERATIONS_DASHBOARD_API: "/api/dashboard/operations",
  CTRL_ALL_COMPLAINTS_API: "/api/complaints/all",

  /* =========================
   USERS APIs
========================= */
  GET_USERS_API: "/api/users",
  GET_ADMIN_USERS_API: "/api/users/admins",
  // Super admin only. PATCH is a partial update of profile fields; /status
  // activates / deactivates (memberships kept, sessions revoked on deactivate).
  UPDATE_USER_API: "/api/users/:id",
  UPDATE_USER_STATUS_API: "/api/users/:id/status",

  /* =========================
   TASK MANAGEMENT APIs
========================= */
  // Tasks
  SOCIETY_GET_TASKS_LIST_API: "/api/tasks",
  SOCIETY_CREATE_TASK_API: "/api/tasks",
  SOCIETY_GET_TASK_DETAILS_API: "/api/tasks/:id",
  SOCIETY_UPDATE_TASK_API: "/api/tasks/:id",
  SOCIETY_DELETE_TASK_API: "/api/tasks/:id",
  SOCIETY_CLONE_TASK_API: "/api/tasks/:id/clone",
  SOCIETY_GET_TASK_HISTORY_API: "/api/tasks/:id/history",
  // Workflow
  SOCIETY_TRANSITION_TASK_API: "/api/tasks/:id/transition",
  SOCIETY_CHANGE_TASK_STATUS_API: "/api/tasks/:id/status",
  SOCIETY_CHANGE_TASK_PRIORITY_API: "/api/tasks/:id/priority",
  SOCIETY_CHANGE_TASK_TITLE_API: "/api/tasks/:id/title",
  // Assignment
  SOCIETY_ASSIGN_TASK_API: "/api/tasks/:id/assign",
  SOCIETY_SELF_ASSIGN_TASK_API: "/api/tasks/:id/self-assign",
  SOCIETY_REASSIGN_TASK_API: "/api/tasks/:id/reassign",
  SOCIETY_DELEGATE_TASK_API: "/api/tasks/:id/delegate",
  SOCIETY_REMOVE_TASK_ASSIGNEE_API: "/api/tasks/:id/assignees/:userId",
  // Watchers
  SOCIETY_ADD_TASK_WATCHER_API: "/api/tasks/:id/watchers",
  SOCIETY_REMOVE_TASK_WATCHER_API: "/api/tasks/:id/watchers/:userId",
  // Comments
  SOCIETY_GET_TASK_COMMENTS_API: "/api/tasks/:id/comments",
  SOCIETY_ADD_TASK_COMMENT_API: "/api/tasks/:id/comments",
  SOCIETY_ADD_TASK_COMMENT_ATTACHMENTS_API: "/api/tasks/:id/comments/:commentId/attachments",
  // Checklist
  SOCIETY_ADD_TASK_CHECKLIST_API: "/api/tasks/:id/checklist",
  SOCIETY_TOGGLE_TASK_CHECKLIST_API: "/api/tasks/:id/checklist/:itemId",
  SOCIETY_DELETE_TASK_CHECKLIST_API: "/api/tasks/:id/checklist/:itemId",
  // Dependencies
  SOCIETY_ADD_TASK_DEPENDENCY_API: "/api/tasks/:id/dependencies",
  SOCIETY_REMOVE_TASK_DEPENDENCY_API: "/api/tasks/:id/dependencies/:dependencyId",
  // Attachments
  SOCIETY_UPLOAD_TASK_ATTACHMENT_API: "/api/tasks/:id/attachments",
  SOCIETY_DOWNLOAD_TASK_ATTACHMENT_API: "/api/tasks/:id/attachments/:attachmentId/download",
  SOCIETY_DELETE_TASK_ATTACHMENT_API: "/api/tasks/:id/attachments/:attachmentId",
  // Projects
  SOCIETY_GET_TASK_PROJECTS_API: "/api/tasks/projects",
  SOCIETY_CREATE_TASK_PROJECT_API: "/api/tasks/projects",
  SOCIETY_GET_TASK_PROJECT_DETAILS_API: "/api/tasks/projects/:projectId",
  SOCIETY_UPDATE_TASK_PROJECT_API: "/api/tasks/projects/:projectId",
  SOCIETY_DELETE_TASK_PROJECT_API: "/api/tasks/projects/:projectId",
  // Collection
  SOCIETY_BULK_CREATE_TASKS_API: "/api/tasks/bulk",
  SOCIETY_GET_TASK_DASHBOARD_API: "/api/tasks/dashboard",

  // ========== NOTICES & CIRCULARS ==========
  SOCIETY_GET_NOTICES_LIST_API: "/api/notices",
  SOCIETY_GET_NOTICE_DETAILS_API: "/api/notices/:id",
  SOCIETY_CREATE_NOTICE_API: "/api/notices",
  SOCIETY_UPDATE_NOTICE_API: "/api/notices/:id",
  SOCIETY_DELETE_NOTICE_API: "/api/notices/:id",
  SOCIETY_PUBLISH_NOTICE_API: "/api/notices/:id/publish",
  SOCIETY_ARCHIVE_NOTICE_API: "/api/notices/:id/archive",
  SOCIETY_RESEND_NOTICE_API: "/api/notices/:id/resend",
  SOCIETY_NOTICE_COMMENTS_API: "/api/notices/:id/comments",
  SOCIETY_DELETE_NOTICE_COMMENT_API: "/api/notices/:id/comments/:commentId",
  SOCIETY_NOTICE_ATTACHMENTS_API: "/api/notices/:id/attachments",
  SOCIETY_DELETE_NOTICE_ATTACHMENT_API: "/api/notices/:id/attachments/:attachmentId",
  SOCIETY_ACKNOWLEDGE_NOTICE_API: "/api/notices/:id/acknowledge",
  SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_API: "/api/notices/:id/acknowledgements",
  SOCIETY_GET_NOTICE_ENUMS_API: "/api/notices/enums",
  SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_API: "/api/notices/audience-options",
  SOCIETY_GET_NOTICE_STATS_API: "/api/notices/stats",
  // Published-only feed scoped to the caller (their wing / flat / audience)
  SOCIETY_GET_NOTICE_BOARD_API: "/api/notices/board",

  // ========== VISITOR MANAGEMENT (VMS) ==========
  // Master record for a visitor (the person, not the visit). One row per
  // (society_id, phone) pair; visits and gate passes hang off it.
  SOCIETY_GET_VISITORS_LIST_API: "/api/visitors",
  SOCIETY_GET_VISITOR_DETAILS_API: "/api/visitors/:id",
  SOCIETY_CREATE_VISITOR_API: "/api/visitors",
  SOCIETY_UPDATE_VISITOR_API: "/api/visitors/:id",
  SOCIETY_DELETE_VISITOR_API: "/api/visitors/:id",
  SOCIETY_BLOCK_VISITOR_API: "/api/visitors/:id/block",
  SOCIETY_UNBLOCK_VISITOR_API: "/api/visitors/:id/unblock",

  // ========== VMS: VISITS ==========
  SOCIETY_GET_VISITS_LIST_API: "/api/visitor-visits",
  SOCIETY_GET_VISIT_DETAILS_API: "/api/visitor-visits/:id",
  SOCIETY_CREATE_VISIT_API: "/api/visitor-visits",
  SOCIETY_UPDATE_VISIT_API: "/api/visitor-visits/:id",
  SOCIETY_DELETE_VISIT_API: "/api/visitor-visits/:id",
  SOCIETY_APPROVE_VISIT_API: "/api/visitor-visits/:id/approve",
  SOCIETY_REJECT_VISIT_API: "/api/visitor-visits/:id/reject",
  SOCIETY_VERIFY_VISIT_OTP_API: "/api/visitor-visits/:id/verify-otp",
  SOCIETY_CHECK_IN_VISIT_API: "/api/visitor-visits/:id/check-in",
  SOCIETY_CHECK_OUT_VISIT_API: "/api/visitor-visits/:id/check-out",

  // ========== VMS: PRE-APPROVALS ==========
  SOCIETY_GET_PRE_APPROVALS_LIST_API: "/api/visitor-pre-approvals",
  SOCIETY_GET_PRE_APPROVAL_DETAILS_API: "/api/visitor-pre-approvals/:id",
  SOCIETY_CREATE_PRE_APPROVAL_API: "/api/visitor-pre-approvals",
  SOCIETY_UPDATE_PRE_APPROVAL_API: "/api/visitor-pre-approvals/:id",
  SOCIETY_DELETE_PRE_APPROVAL_API: "/api/visitor-pre-approvals/:id",

  // ========== VMS: GATE PASSES ==========
  SOCIETY_GET_GATE_PASSES_LIST_API: "/api/visitor-gate-passes",
  SOCIETY_GET_GATE_PASS_DETAILS_API: "/api/visitor-gate-passes/:id",
  SOCIETY_CREATE_GATE_PASS_API: "/api/visitor-gate-passes",
  SOCIETY_UPDATE_GATE_PASS_API: "/api/visitor-gate-passes/:id",
  SOCIETY_DELETE_GATE_PASS_API: "/api/visitor-gate-passes/:id",
  SOCIETY_REVOKE_GATE_PASS_API: "/api/visitor-gate-passes/:id/revoke",

  // ========== VMS: DELIVERY LOGS ==========
  SOCIETY_GET_DELIVERIES_LIST_API: "/api/visitor-delivery-logs",
  SOCIETY_GET_DELIVERY_DETAILS_API: "/api/visitor-delivery-logs/:id",
  SOCIETY_CREATE_DELIVERY_API: "/api/visitor-delivery-logs",
  SOCIETY_UPDATE_DELIVERY_API: "/api/visitor-delivery-logs/:id",
  SOCIETY_DELETE_DELIVERY_API: "/api/visitor-delivery-logs/:id",
  SOCIETY_COMPLETE_DELIVERY_API: "/api/visitor-delivery-logs/:id/complete",

  // ========== VMS: CAB LOGS ==========
  SOCIETY_GET_CABS_LIST_API: "/api/visitor-cab-logs",
  SOCIETY_GET_CAB_DETAILS_API: "/api/visitor-cab-logs/:id",
  SOCIETY_CREATE_CAB_API: "/api/visitor-cab-logs",
  SOCIETY_UPDATE_CAB_API: "/api/visitor-cab-logs/:id",
  SOCIETY_DELETE_CAB_API: "/api/visitor-cab-logs/:id",
  SOCIETY_COMPLETE_CAB_API: "/api/visitor-cab-logs/:id/complete",

  // ========== VMS: ACTIVITY LOGS (read-only) ==========
  SOCIETY_GET_VMS_ACTIVITY_LOGS_API: "/api/visitor-activity-logs",
  SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_API: "/api/visitor-activity-logs/export",

  // ========== VMS: SETTINGS ==========
  SOCIETY_GET_VMS_SETTINGS_API: "/api/vms-settings",
  SOCIETY_UPDATE_VMS_SETTINGS_API: "/api/vms-settings",
  /* =========================
   MEMBER SELF-SERVICE APIs
  ========================= */
  // A namespace of its own rather than the admin finance endpoints with a flag.
  // None of these carry an admin permission: authorization is membership of the
  // society plus a hard scope to the flats the caller owns or occupies, resolved
  // server-side from the JWT. Identity is never accepted as input — a flat_id is
  // a filter that can narrow a result, never widen it.
  MEMBER_SUMMARY_API: "/api/member/summary",
  MEMBER_FLATS_API: "/api/member/flats",
  MEMBER_INVOICES_API: "/api/member/invoices",
  MEMBER_INVOICE_DETAILS_API: "/api/member/invoices/:id",
  MEMBER_PAYMENTS_API: "/api/member/payments",
  MEMBER_PAYMENT_DETAILS_API: "/api/member/payments/:id",
  // Statement of account. Deliberately not paginated — a statement that stops
  // halfway is a wrong number.
  MEMBER_LEDGER_API: "/api/member/ledger",
  // The resident complaint flow runs entirely here, on member_portal.complaints —
  // no complaint.* staff permission is involved.
  MEMBER_COMPLAINTS_API: "/api/member/complaints",
  MEMBER_COMPLAINT_ENUMS_API: "/api/member/complaints/enums",
  MEMBER_COMPLAINT_DETAILS_API: "/api/member/complaints/:id",
  MEMBER_COMPLAINT_ATTACHMENTS_API: "/api/member/complaints/:id/attachments",
  MEMBER_COMPLAINT_COMMENTS_API: "/api/member/complaints/:id/comments",
  MEMBER_RATE_COMPLAINT_API: "/api/member/complaints/:id/rate",
  MEMBER_NOTICES_API: "/api/member/notices",
  MEMBER_ACKNOWLEDGE_NOTICE_API: "/api/member/notices/:id/acknowledge",

};


export default apiEndpoints;

